const IconData = [
    {
        id: 1,
        cover: require("../../Assets/Icons/lounge.png"),
        title:"Seating Lounge",
        altTag:"Sobha Aranya"
    },
    {
        id: 2,
        cover: require("../../Assets/Icons/badminton_court.png"),
        title:"Badminton Court",
        altTag:"Sobha Aranya"
    },
    {
        id: 3,
        cover: require("../../Assets/Icons/yoga.png"),
        title:"Yoga Deck",
        altTag:"Sobha Aranya  price"
    },
    {
        id: 4,
        cover: require("../../Assets/Icons/gym.png"),
        title:"Gym",
        altTag:"Sobha Aranya  plans"
    },
    {
        id: 5,
        cover: require("../../Assets/Icons/multipurpose_hall.png"),
        title:"Multipurpose Hall",
        altTag:"Sobha Aranya  Expressway"
    },
    {
        id: 6,
        cover: require("../../Assets/Icons/pool_icon.png"),
        title:"Pool with Jacuzzi",
        altTag:"Sobha Aranya  Expressway"
    },
    {
        id: 7,
        cover: require("../../Assets/Icons/golf_icon.png"),
        title:"9 Hole Golf",
        altTag:"Sobha Aranya  Expressway"
    },
    {
        id: 8,
        cover: require("../../Assets/Icons/restourent.png"),
        title:"Operational Restaurants",
        altTag:"Sobha Aranya  Expressway"
    },
]

export default IconData